/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsInfoCircle } from 'react-icons/bs';

export const IndeterminateCheckbox = forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = useRef();
    const resolvedRef = ref || defaultRef;

    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return <input type="checkbox" ref={resolvedRef} {...rest} />;
  }
);

export const SelectionColumn = ({
  name,
  className,
  setMinWidth,
  setMaxWidth,
  controlled = false,
  onRowSelectionChange,
  onAllRowsSelectionChange,
} = {}) => {
  const selectionID = name || 'selection';
  let headerProps = (table) => table.getToggleAllRowsSelectedProps();
  let cellProps = (row) => row.getToggleRowSelectedProps();
  if (controlled) {
    headerProps = (table) => ({
      ...table.getToggleAllRowsSelectedProps(),
      onChange: onAllRowsSelectionChange?.(table),
    });
    cellProps = (row) => ({
      ...row.getToggleRowSelectedProps(),
      onChange: onRowSelectionChange?.(row),
    });
  }

  return {
    id: selectionID,
    Header: (table) => <IndeterminateCheckbox {...headerProps(table)} />,
    Cell: ({ row }) => <IndeterminateCheckbox {...cellProps(row)} />,
    className,
    setMinWidth,
    setMaxWidth,
  };
};

export const renderHeaderWithHover = (
  title,
  accessor,
  fieldDescriptions,
  iconNewLine = false
) => {
  if (!(accessor in fieldDescriptions)) {
    return title;
  }

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id={`tooltip-${accessor}`} style={{ position: 'fixed' }}>
          {fieldDescriptions[accessor]}
        </Tooltip>
      }
    >
      <span>
        {title} {iconNewLine ? <br /> : ' '}
        <span className="textGreen">
          <BsInfoCircle size={17} />
        </span>
      </span>
    </OverlayTrigger>
  );
};
